<div class="image-viewer">
    <div (click)="dialogRef.close()" class="close" matTooltipPosition="after">
        <i class="fa fa-times"></i>
    </div>
    <div class="pages" *ngIf="numberOfPages?.length > 1">
        @for (page of numberOfPages; track $index) {
            <div class="page" (click)="loadPage(page)" [class.active]="page === currentPage">
                {{page}}
            </div>
        }
    </div>
    <swiper-container #swiperRef navigation="true" zoom="true" loop="true" mousewheel="false" (wheel)="onScroll($event)">
        @if (data.singlePdf) {
            <swiper-slide>
                <div class="swiper-zoom-container" data-swiper-zoom="8">
                    <canvas #pdfCanvas></canvas>
                </div>
            </swiper-slide>
        } @else if (data.singleImage) {
            <swiper-slide>
                <div class="swiper-zoom-container">
                    <img [src]="data.singleImage"/>
                </div>
            </swiper-slide>
        } @else {
            @for (image of images; track image) {
                <swiper-slide>
                    <div class="swiper-zoom-container">
                        <img [src]="image.image"/>
                        <div class="info">
                            <app-status-chip [statusKey]="image.ttmImage.status.key" [ttmStatuses]="ttmStatuses"></app-status-chip>

                            <mat-chip>
                                {{image.ttmImage.created_at | date : 'd MMM yyyy H:mm'}}
                            </mat-chip>
                            @if (Features.ShowSensetiveInformation | hasFeature) {
                                <mat-chip>
                                    <i class="fa-solid fa-user-large me-1"></i> {{image.ttmImage.user?.name}}
                                </mat-chip>
                            }
                            <mat-chip *ngIf="ttmImageDistance.get(image.ttmImage.id)" (click)="onOpenLocation(image.ttmImage)" class="clickable">
                                <i class="fa-solid fa-location-dot"></i> {{ttmImageDistance.get(image.ttmImage.id)}}
                            </mat-chip>
                        </div>
                    </div>
                </swiper-slide>
            }
        }
    </swiper-container>
</div>
